<template>
  <div id="contenedor-editar-obra">
    <v-form ref="editarObra" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Obra
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="2">
            <custom-select
              v-model="obra.ejercicio"
              label="Ejercicio*"
              :items="getEjerciciosRange"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-text-field
              v-model="obra.clave"
              label="Clave*"
              :rules="[mixReglas.requerido]"
              v-on:keypress.enter="mixActualizarObra"
              required
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="d-flex align-center">
            <Select
              v-model="obra.etiquetas"
              @change="onEtiquetasChange"
              label="Etiquetas"
              placeholder="Seleccione las etiquetas"
              :items="getEtiquetas"
              deletable-chips
              multiple
              small-chips
              hide-details
              item-text="title"
              item-value="id">
            </Select>
          </v-col>
          <v-col class="d-flex align-center">
            <v-btn icon @click="mostrarDialogNuevaEtiqueta = true">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <custom-text-area
              v-model="obra.meta"
              label="Meta*"
              :rules="[mixReglas.requerido]"
              v-on:keypress.enter="mixActualizarObra"
              required
            >
            </custom-text-area>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.importe"
              label="Importe"
              esDinero
              v-on:keypress.enter="mixActualizarObra"
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.importeIva"
              label="Importe IVA"
              esDinero
              v-on:keypress.enter="mixActualizarObra"
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model.number="obra.total"
              label="Total"
              esDinero
              v-on:keypress.enter="mixActualizarObra"
            >
            </custom-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.etapa"
              label="Etapa"
              :items="itemsetapa"
              item-text="etapa"
              item-value="valor"
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.idTipo"
              label="Tipo de Obra*"
              :items="tiposObras"
              :rules="[mixReglas.requerido]"
              item-text="descripcion"
              item-value="id"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.idSubtipo"
              label="SubTipo de Obra*"
              :items="getSubTipoObraPorTipo"
              item-text="descripcion"
              item-value="id"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <custom-select
              v-model="obra.tipoProyecto"
              label="Tipo de Proyecto"
              :items="itemstipodeproyecto"
              item-text="proyecto"
              item-value="valor"
            >
            </custom-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <custom-select
              v-model="obra.idPrograma"
              label="Programa"
              :items="programasInversiones"
              item-text="nombre"
              item-value="id"
              required
            >
            </custom-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <custom-select
              v-model="obra.ubicacion.idMunicipio"
              label="Municipio*"
              :items="municipios"
              item-text="nombre"
              item-value="id"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              required
            >
            </custom-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model="obra.ubicacion.localidad"
              label="Localidad*"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              v-on:keypress.enter="mixActualizarObra"
              required
            >
            </custom-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-text-field
              v-model="obra.ubicacion.ubicacion"
              label="Ubicación*"
              :rules="[mixReglas.requerido]"
              v-show="mostrarcamposubicacion"
              v-on:keypress.enter="mixActualizarObra"
              required
            >
            </custom-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaSolicitudRecursos"
              label="Fecha de Solicitud de Recursos"
            >
            </custom-date-picker>
          </v-col> -->
          <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaProbableInicio"
              label="Fecha Probable de Inicio"
            >
            </custom-date-picker>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <custom-date-picker
              v-model="obra.fechaProbableTermino"
              label="Fecha Probable de Termino"
            >
            </custom-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels accordion flat>
            <v-expansion-panel @click="showhide">
              <v-expansion-panel-header>
                <v-card-title>Datos Opcionales de la Ubicación</v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <custom-select
                      v-model="obra.ubicacion.idMunicipio"
                      label="Municipio*"
                      :items="municipios"
                      item-text="nombre"
                      item-value="id"
                      :rules="[mixReglas.requerido]"
                      required
                    >
                    </custom-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <custom-text-field
                      v-model="obra.ubicacion.localidad"
                      label="Localidad*"
                      :rules="[mixReglas.requerido]"
                      v-on:keypress.enter="mixActualizarObra"
                      required
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-select
                      v-model="obra.ubicacion.tipoLocalidad"
                      label="Tipo de Localidad"
                      :items="itemstipolocalidad"
                    >
                    </custom-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <custom-text-field
                      v-model="obra.ubicacion.ubicacion"
                      label="Ubicación*"
                      :rules="[mixReglas.requerido]"
                      v-on:keypress.enter="mixActualizarObra"
                      required
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model="obra.ubicacion.latitud"
                      label="Latitud"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model="obra.ubicacion.longitud"
                      label="Longitud"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="8">
                    <custom-text-field
                      v-model="obra.ubicacion.sitio"
                      label="Sitio"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-switch
                      v-model="obra.ubicacion.cabeceraMunicipial"
                      inset
                      label="¿Es Cabecera Municipal?"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title> Datos Opcionales del Impacto </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model.number="obra.impacto.beneficiados"
                      label="Beneficiados"
                      type="number"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model.number="obra.impacto.metaFisica"
                      label="Meta Fisica"
                      type="number"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <custom-text-field
                      v-model="obra.impacto.metaFisicaUnidad"
                      label="Unidad Meta Fisica"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.justificacionTecnica"
                      label="Justificación Técnica"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model.number="obra.impacto.avanceFisicoActual"
                      prefix="%"
                      label="Avance Fisico Actual"
                      type="number"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <custom-text-field
                      v-model.number="obra.impacto.avanceProgramadoCierre"
                      prefix="%"
                      label="Avance Programado Cierre"
                      type="number"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.descripcionTotalObra"
                      label="Descripcion Total Obra"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.conceptosEjecutar"
                      label="Conceptos a ejecutar de la obra"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.problematica"
                      label="Problematica"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <custom-text-area
                      v-model="obra.impacto.justificacionSocial"
                      label="Justificación Social"
                      v-on:keypress.enter="mixActualizarObra"
                    >
                    </custom-text-area>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarObra"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-dialog v-model="mostrarDialogNuevaEtiqueta" max-width="450px" scrollable>
      <nueva-etiqueta
        @cerrar="cerrarAgregarEtiqueta"
        :modulo="'OBRAS'">
      </nueva-etiqueta>
    </v-dialog>
  </div>
</template>

<script>
import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Select from '@/components/inputs/sinColumnas/Select.vue';
import NuevaEtiqueta from '@/components/administracion/configuracion/catalogos/etiquetas/Nueva.vue';
import mixObras from './mixObras';

const hoy = new Date();

export default {
  name: 'ObrasEditar',
  mixins: [mixObras],
  props: {
    obraEditar: Object,
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomTextArea,
    CustomDatePicker,
    CustomButton,
    NuevaEtiqueta,
    Select,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      mostrarcamposubicacion: true,
      mostrarDialogNuevaEtiqueta: false,
      etiquetasAnteriores: [], // Para detectar cuál etiqueta se eliminó
      itemsetapa: [
        { etapa: 'Nueva', valor: 1 },
        { etapa: 'Ampliación', valor: 2 },
        { etapa: 'Rehabilitación', valor: 3 },
      ],
      itemstipodeproyecto: [
        { proyecto: 'Social', valor: 1 },
        { proyecto: 'Productivo', valor: 2 },
        { proyecto: 'Apoyo', valor: 3 },
      ],
      itemstipolocalidad: ['Urbana', 'Rural'],
      etiquetasFiltros: {
        modulo: 'OBRAS',
      },
      obra: {
        idPrograma: this.obraEditar.idPrograma, // (Catalogo)
        idTipo: this.obraEditar.idTipo, // (Catalogo)
        idSubtipo: this.obraEditar.idSubtipo, // (Catalogo)
        ejercicio: this.obraEditar.ejercicio,
        clave: this.obraEditar.clave,
        meta: this.obraEditar.meta,
        importe: this.obraEditar.importe || 0,
        importeIva: this.obraEditar.importeIva || 0,
        total: this.obraEditar.total || 0,
        etapa: this.obraEditar.etapa, // (1=> Nueva, 2 => Amplicación, 3 => Rehabilitación)
        tipoProyecto: this.obraEditar.tipoProyecto, // (1 => Social, 2 => Productivo, 3 => Apoyo)
        fechaSolicitudRecursos: this.obraEditar.fechaSolicitudRecursos,
        fechaProbableInicio: this.obraEditar.fechaProbableInicio,
        fechaProbableTermino: this.obraEditar.fechaProbableTermino,
        ubicacion: {
          idMunicipio: this.obraEditar.ubicacion.idMunicipio, // (Catalogo)
          ubicacion: this.obraEditar.ubicacion.ubicacion,
          localidad: this.obraEditar.ubicacion.localidad,
          latitud: this.obraEditar.ubicacion.latitud,
          longitud: this.obraEditar.ubicacion.longitud,
          sitio: this.obraEditar.ubicacion.sitio,
          cabeceraMunicipial: this.obraEditar.ubicacion.cabeceraMunicipial,
          tipoLocalidad: this.obraEditar.ubicacion.tipoLocalidad,
        },
        impacto: {
          beneficiados: this.obraEditar.impacto.beneficiados,
          metaFisica: this.obraEditar.impacto.metaFisica,
          metaFisicaUnidad: this.obraEditar.impacto.metaFisicaUnidad,
          justificacionTecnica: this.obraEditar.impacto.justificacionTecnica,
          justificacionSocial: this.obraEditar.impacto.justificacionSocial,
          problematica: this.obraEditar.impacto.problematica,
          avanceFisicoActual: this.obraEditar.impacto.avanceFisicoActual,
          avanceProgramadoCierre: this.obraEditar.impacto.avanceProgramadoCierre,
          descripcionTotalObra: this.obraEditar.impacto.descripcionTotalObra,
          conceptosEjecutar: this.obraEditar.impacto.conceptosEjecutar,
        },
        etiquetas: this.obraEditar.etiquetas.map((etiqueta) => etiqueta.idEtiqueta) || [],
      },
    };
  },
  apollo: {
    etiquetas: {
      query: ETIQUETAS,
      variables() {
        return {
          filtros: this.etiquetasFiltros,
        };
      },
    },
  },
  computed: {
    getEjerciciosRange() {
      const anioActual = hoy.getFullYear();
      return this.$range(2021, (anioActual + 2)).reverse();
    },
    getEtiquetas() {
      return this.etiquetas ? this.etiquetas.map((etiqueta) => ({
        title: etiqueta.nombre,
        subtitle: null,
        avatar: '',
        id: etiqueta.id,
      })) : [];
    },
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    cerrarAgregarEtiqueta() {
      this.mostrarDialogNuevaEtiqueta = false;
    },
    limpiarFormulario() {
      this.$refs.editarObra.reset();
    },
    showhide() {
      this.mostrarcamposubicacion = !this.mostrarcamposubicacion;
    },
    async onEtiquetasChange(nuevasEtiquetas) {
      // Detectar si se eliminó una etiqueta
      const etiquetasEliminadas = this.etiquetasAnteriores.filter(
        (etiquetaAnterior) => !nuevasEtiquetas.includes(etiquetaAnterior),
      );

      // Detectar si se agregó una nueva etiqueta
      const etiquetasAgregadas = nuevasEtiquetas.filter(
        (nuevaEtiqueta) => !this.etiquetasAnteriores.includes(nuevaEtiqueta),
      );

      // Manejar etiquetas eliminadas
      if (etiquetasEliminadas.length > 0) {
        const idEtiquetaEliminada = etiquetasEliminadas[0];
        const etiquetaRelacion = this.obraEditar.etiquetas.find(
          (etiqueta) => etiqueta.idEtiqueta === idEtiquetaEliminada,
        );

        if (etiquetaRelacion) {
          try {
            await this.mixRemoverEtiquetaDeObra(etiquetaRelacion.id, this.obraEditar.id);
            this.mixMensajeSuccess('Etiqueta eliminada correctamente');
          } catch (error) {
            this.mixMensajeError(error);
            // Revertir el cambio en caso de error
            this.obra.etiquetas = [...this.etiquetasAnteriores];
            return;
          }
        }
      }

      // Manejar etiquetas agregadas
      if (etiquetasAgregadas.length > 0) {
        try {
          const resultado = await this.mixAgregarEtiquetaObra(
            this.obraEditar.id,
            etiquetasAgregadas,
          );

          if (resultado.err) {
            throw resultado.err;
          }

          this.mixMensajeSuccess('Etiqueta agregada correctamente');

          // Actualizar la lista local de etiquetas de la obra editada
          // para futuras operaciones de eliminación
          const nuevasEtiquetasRelacion = resultado.data.agregarEtiquetas;
          this.obraEditar.etiquetas.push(...nuevasEtiquetasRelacion);
        } catch (error) {
          this.mixMensajeError(error);
          // Revertir el cambio en caso de error
          this.obra.etiquetas = [...this.etiquetasAnteriores];
          return;
        }
      }

      // Actualizar el array de etiquetas anteriores solo si no hubo errores
      this.etiquetasAnteriores = [...nuevasEtiquetas];
    },
  },
  mounted() {
    // Inicializar el array de etiquetas anteriores
    this.etiquetasAnteriores = [...this.obra.etiquetas];
  },
};
</script>
